/// JTF3-PRO-added-AB-22-04-13

jQuery( document ).ready( function( $ ) {
	function SECUREFILE() {
		console.log( 'JTF SecureFile V2.0' )
		this.init()
	}

	SECUREFILE.prototype.getCookie = function ( name ) {
		const value = `; ${document.cookie}`
		const parts = value.split(`; ${name}=`)

		if ( parts.length === 2 ) {
			return parts.pop().split( ';' ).shift()
		}
	}

	SECUREFILE.prototype.swapFormForMedia = function ( id, parent ) {
		console.log( 'swapFormForMedia' )
		const self = this
		const xhr  = new XMLHttpRequest()
		let url    = '/wp-json/jtf/v1/media/item?id=' + id
		console.log( url )
		
		xhr.open( 'GET', url )
		xhr.onload = function( response ) {
			if ( xhr.status === 200) {
				const json = JSON.parse( response.currentTarget.response )

				const container = $('<div/>',
					{
						'class': 'jtf__securefileblock--container'
					}
				)

				const title = $('<span/>',
					{
						'class': 'jtf__securefileblock--title'
					}
				)

				const subtitle = $('<span/>',
					{
						'class': 'jtf__securefileblock--subtitle'
					}
				)

				title.append( 'Download' )
				container.append( title )

				subtitle.append( 'Click to download the resource' )
				container.append( subtitle )

				const button = $('<a/>',
					{
						'class': 'jtf__securefileblock--button btn btn__default',
						'href': json,
						'download' : json
					}
				)

				button.html( 'DOWNLOAD' )
				container.append( button )
				parent.html( container )
			}
		};
		xhr.send()
	}

	SECUREFILE.prototype.init = function () {
		const self = this
		if ( $( '.jtf__securefileblock--embed' ).length > 0 ) {
			console.log('securefile js log')
			$( '.jtf__securefileblock--embed' ).each( function() {
				let pageId = $( this ).attr( 'data-pageid' )
				let itemId = $( this ).attr( 'data-id' )
				console.log('pagId ' + pageId)
				console.log('itemId ' + itemId)
				let cookie = self.getCookie( 'secure_download_' + pageId )
				console.log('cooks ' + cookie)

				if ( cookie == 1 ) {
					let item = self.swapFormForMedia( itemId, $( this ) )
					console.log( item )
				}
			} )
		}
	}

	// Check SECUREFILE is used on this page before instantiating
	if ( $( '.wp-block-jtf-jtf-securefile' ).length > 0 ) {
		new SECUREFILE()
	}
} )
